import React from 'react';
import { useSite } from '../content/SiteContext';
import { faqSchema } from '../lib/schema';
import { PageMeta, PageHero, CtaBand, FaqList, WhatsAppButton } from '../components/ui';

const FAQ = () => {
  const { FAQS, PACKAGES } = useSite();
  const packageFaqs = PACKAGES.map((p) => ({
    q: `What is included in the ${p.name}?`,
    a: `${p.name} (AED ${p.price}, ${p.duration.toLowerCase()}): ${p.includes.join(', ')}. Not included: ${p.excludes.join(', ').toLowerCase()}.`
  }));
  return (
    <>
      <PageMeta
        title="Mobile Car Wash FAQ | Prices, Areas & Booking | Quick Way"
        description="Mobile car wash questions answered: prices, package inclusions, Abu Dhabi and Dubai service areas, building car parks, payment and cancellations."
        path="/faq"
        crumbs={[{ name: 'FAQ', path: '/faq' }]}
        jsonLd={[faqSchema([...FAQS, ...packageFaqs])]}
      />
      <PageHero eyebrow="Help" title="Frequently asked questions">
        <p>Everything you need to know before booking a mobile car wash with Quick Way.</p>
      </PageHero>
      <section className="section">
        <div className="container container--narrow">
          <h2 className="h-section">Booking, prices and areas</h2>
          <FaqList items={FAQS} />
          <h2 className="h-section h-section--spaced">Packages</h2>
          <FaqList items={packageFaqs} />
          <div className="note-box note-box--center">
            <p><strong>Still have a question?</strong> Our team answers on WhatsApp.</p>
            <WhatsAppButton text="Hi Quick Way, I have a question." source="faq" />
          </div>
        </div>
      </section>
      <CtaBand source="faq" />
    </>
  );
};

export default FAQ;
